<template>
  <div id="app">
    <router-view></router-view>
    <loading message="加载中..."></loading>
  </div>
</template>

<script>
import Loading from './components/loading'

export default {
  name: 'app',
  data () {
    return {
    }
  },
  components: {
    Loading
  },
  mounted: function () {
  }
}
</script>

